/**
 * Bet Ticker More-filter cascade wiring.
 * Previous pickers → tickerBQ; Flag Final → tickerFlagFinalBQ; live → page dataSource.
 */

export type TickerFilterDataSource = 'pg' | 'bq' | 'flag-final-bq'

/** Filter-options backend for Sub Game → Event cascade. */
export function filterOptionsDataSource(opts: {
  previous: boolean
  flagFinal?: boolean
  pageDataSource: TickerFilterDataSource
}): TickerFilterDataSource {
  if (opts.flagFinal || opts.pageDataSource === 'flag-final-bq') return 'flag-final-bq'
  return opts.previous ? 'bq' : opts.pageDataSource
}

/** Sub Game → Event / Event → Market cascade body — always when set. */
export function filterOptionsCascade(opts: {
  sport: string
  event: string
}): { eventType?: string; eventName?: string } {
  return {
    ...(opts.sport !== 'all' ? { eventType: opts.sport } : {}),
    ...(opts.event ? { eventName: opts.event } : {}),
  }
}
